// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane.tokens-pane {
  margin-right: 1rem;
  text-align: left;
}
.pane.tokens-pane .tokens-list {
  column-gap: 1rem;
  display: grid;
  grid-template-columns: max-content max-content max-content auto max-content;
  row-gap: 1rem;
}
.pane.tokens-pane .token-card {
  display: grid;
  grid-column: 1/-1;
  grid-row: span 2;
  grid-template-columns: subgrid;
  row-gap: 0.5rem;
}
.pane.tokens-pane .token-description-tile, .pane.tokens-pane label.token-description {
  display: grid;
  grid-column: span 4;
  grid-template-columns: subgrid;
}
.pane.tokens-pane input.token-description {
  grid-column: span 3;
  margin: 0;
}
.pane.tokens-pane .token-last-used {
  grid-column: 2;
}
.pane.tokens-pane .token-expires {
  grid-column: 3;
}
.pane.tokens-pane .token-created {
  grid-column: 4;
}
.pane.tokens-pane .token-actions {
  grid-row: span 2;
}
.pane.tokens-pane button.token-action {
  width: 7rem;
}
.pane.tokens-pane .token-card.new {
  border-bottom: var(--border-elevated);
  padding: 0.5rem 0 1rem 0;
}
.pane.tokens-pane .token-card.new label.token-expires {
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
}
.pane.tokens-pane .token-card.new label.token-expires .label-text {
  text-align: right;
}
.pane.tokens-pane .token-new-title {
  color: var(--color-base-text);
  font-size: 1rem;
  font-weight: normal;
  grid-column: 2/-1;
}
.pane.tokens-pane .pane-title {
  grid-column: 1/-1;
}
.pane.tokens-pane .tokens-options {
  margin: 0 1rem -0.5rem 0;
  padding: 0 1rem;
}
.pane.tokens-pane .tokens-options .label-text {
  margin: 0 0 0 0.5rem;
  width: unset;
}
.pane.tokens-pane .token-card:not(.new) .token-last-used, .pane.tokens-pane .token-card:not(.new) .token-created, .pane.tokens-pane .token-card:not(.new) .token-expires {
  color: var(--color-base-text);
  font-size: 0.8rem;
  margin: -0.5rem 1rem 0 0;
}
.pane.tokens-pane .token-card:not(.new) .token-last-used .timestamp-display, .pane.tokens-pane .token-card:not(.new) .token-created .timestamp-display, .pane.tokens-pane .token-card:not(.new) .token-expires .timestamp-display {
  margin-left: 0.25rem;
}
.pane.tokens-pane .token-card.expired .token-description, .pane.tokens-pane .token-card.expired .token-last-used, .pane.tokens-pane .token-card.expired .token-expires, .pane.tokens-pane .token-card.expired .expiration {
  color: var(--color-elevated-warn);
}
.pane.tokens-pane .token-card.expires-soon .expiration {
  color: var(--color-elevated-warn);
}
.pane.tokens-pane .created-token-backdrop {
  align-items: center;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
}
.pane.tokens-pane .created-token {
  background-color: var(--color-base-canvas-translucent);
  border: var(--border-elevated);
  color: var(--color-elevated-text);
  line-height: 1.3rem;
  margin-top: -15%;
  padding: 2rem;
  text-align: left;
  width: 38rem;
  z-index: 1000;
}
.pane.tokens-pane .created-token-title {
  font-weight: normal;
  font-size: 1.3rem;
}
.pane.tokens-pane .created-token-message {
  margin: 1rem 0;
}
.pane.tokens-pane .created-token-message em {
  color: var(--color-elevated-warn);
  font-style: normal;
}
.pane.tokens-pane .created-token-value {
  -webkit-user-select: all;
  user-select: all;
  font-family: ui-monospace;
  font-size: 0.7rem;
  height: 7rem;
  margin: 0;
  overflow-wrap: break-word;
  width: calc(100% - 1.5rem);
}
.pane.tokens-pane .created-token-actions {
  margin-top: 1rem;
  text-align: right;
}
.pane.tokens-pane .created-token-close {
  color: var(--color-elevated-warn);
}
.pane.tokens-pane .created-token-copy, .pane.tokens-pane .created-token-close {
  width: 6rem;
}
.pane.tokens-pane .created-token-copy {
  margin-left: 2rem;
}
.pane.tokens-pane .icon.copy, .pane.tokens-pane .icon.copied {
  margin-right: 0.6rem;
}
.pane.tokens-pane .icon.copy {
  fill: var(--color-elevated-text);
}
.pane.tokens-pane .created-token-copy:has(.icon.copied) {
  color: var(--color-elevated-success);
  fill: var(--color-elevated-success);
}

.windows .pane.tokens-pane .created-token-value, .chrome .pane.tokens-pane .created-token-value {
  font-family: ui-monospace, monospace;
}`, "",{"version":3,"sources":["webpack://./src/style/panes/account/account_tokens.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,aAAA;EACA,2EAAA;EACA,aAAA;AACJ;AAEE;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AADJ;AAIE;EACE,mBAAA;EACA,SAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;AAKE;EACE,cAAA;AAHJ;AAKE;EACE,cAAA;AAHJ;AAKE;EACE,gBAAA;AAHJ;AAME;EACE,WAAA;AAJJ;AAOE;EACE,qCAAA;EACA,wBAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AANJ;AAQI;EACE,iBAAA;AANN;AAUE;EACE,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AARJ;AAWE;EACE,iBAAA;AATJ;AAYE;EACE,wBAAA;EACA,eAAA;AAVJ;AAYI;EACE,oBAAA;EACA,YAAA;AAVN;AAeI;EACE,6BAAA;EACA,iBAAA;EACA,wBAAA;AAbN;AAeM;EACE,oBAAA;AAbR;AAmBI;EACE,iCAAA;AAjBN;AAsBI;EACE,iCAAA;AApBN;AAwBE;EACE,mBAAA;EACA,mCAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAtBJ;AAwBE;EACE,sDAAA;EACA,8BAAA;EACA,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAtBJ;AAwBE;EACE,mBAAA;EACA,iBAAA;AAtBJ;AAyBE;EACE,cAAA;AAvBJ;AAwBI;EACE,iCAAA;EACA,kBAAA;AAtBN;AAyBE;EACE,wBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,0BAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,iBAAA;AAxBJ;AA2BE;EACE,iCAAA;AAzBJ;AA4BE;EACE,WAAA;AA1BJ;AA6BE;EACE,iBAAA;AA3BJ;AA8BE;EACE,oBAAA;AA5BJ;AA+BE;EACE,gCAAA;AA7BJ;AAgCE;EACE,oCAAA;EACA,mCAAA;AA9BJ;;AAmCE;EACE,oCAAA;AAhCJ","sourcesContent":[".pane.tokens-pane {\n  margin-right: 1rem;\n  text-align: left;\n\n  .tokens-list {\n    column-gap: 1rem;\n    display: grid;\n    grid-template-columns: max-content max-content max-content auto max-content;\n    row-gap: 1rem;\n  }\n\n  .token-card {\n    display: grid;\n    grid-column: 1 / -1;\n    grid-row: span 2;\n    grid-template-columns: subgrid;\n    row-gap: 0.5rem;\n  }\n\n  .token-description-tile, label.token-description {\n    display: grid;\n    grid-column: span 4;\n    grid-template-columns: subgrid;\n  }\n\n  input.token-description {\n    grid-column: span 3;\n    margin: 0;\n  }\n\n  .token-last-used {\n    grid-column: 2;\n  }\n  .token-expires {\n    grid-column: 3;\n  }\n  .token-created {\n    grid-column: 4;\n  }\n  .token-actions {\n    grid-row: span 2;\n  }\n\n  button.token-action {\n    width: 7rem;\n  }\n\n  .token-card.new {\n    border-bottom: var(--border-elevated);\n    padding: 0.5rem 0 1rem 0;\n  }\n\n  .token-card.new label.token-expires {\n    display: grid;\n    grid-column: span 2;\n    grid-template-columns: subgrid;\n\n    .label-text {\n      text-align: right;\n    }\n  }\n\n  .token-new-title {\n    color: var(--color-base-text);\n    font-size: 1rem;\n    font-weight: normal;\n    grid-column: 2 / -1;\n  }\n\n  .pane-title {\n    grid-column: 1 / -1;\n  }\n\n  .tokens-options {\n    margin: 0 1rem -0.5rem 0;\n    padding: 0 1rem;\n\n    .label-text {\n      margin: 0 0 0 0.5rem;\n      width: unset;\n    }\n  }\n\n  .token-card:not(.new) {\n    .token-last-used, .token-created, .token-expires {\n      color: var(--color-base-text);\n      font-size: 0.8rem;\n      margin: -0.5rem 1rem 0 0;\n\n      .timestamp-display {\n        margin-left: 0.25rem;\n      }\n    }\n  }\n\n  .token-card.expired {\n    .token-description, .token-last-used, .token-expires, .expiration {\n      color: var(--color-elevated-warn);\n    }\n  }\n\n  .token-card.expires-soon {\n    .expiration {\n      color: var(--color-elevated-warn);\n    }\n  }\n\n  .created-token-backdrop {\n    align-items: center;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    display: flex;\n    justify-content: center;\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 999;\n  }\n  .created-token {\n    background-color: var(--color-base-canvas-translucent);\n    border: var(--border-elevated);\n    color: var(--color-elevated-text);\n    line-height: 1.3rem;\n    margin-top: -15%;\n    padding: 2rem;\n    text-align: left;\n    width: 38rem;\n    z-index: 1000;\n  }\n  .created-token-title {\n    font-weight: normal;\n    font-size: 1.3rem;\n  }\n\n  .created-token-message {\n    margin: 1rem 0;\n    em {\n      color: var(--color-elevated-warn);\n      font-style: normal;\n    }\n  }\n  .created-token-value {\n    -webkit-user-select: all;\n    user-select: all;\n    font-family: ui-monospace;\n    font-size: 0.7rem;\n    height: 7rem;\n    margin: 0;\n    overflow-wrap: break-word;\n    width: calc(100% - 1.5rem);\n  }\n\n  .created-token-actions {\n    margin-top: 1rem;\n    text-align: right;\n  }\n\n  .created-token-close {\n    color: var(--color-elevated-warn);\n  }\n\n  .created-token-copy, .created-token-close {\n    width: 6rem;\n  }\n\n  .created-token-copy {\n    margin-left: 2rem;\n  }\n\n  .icon.copy, .icon.copied {\n    margin-right: 0.6rem;\n  }\n\n  .icon.copy {\n    fill: var(--color-elevated-text);\n  }\n\n  .created-token-copy:has(.icon.copied) {\n    color: var(--color-elevated-success);\n    fill: var(--color-elevated-success);\n  }\n}\n\n.windows, .chrome {\n  .pane.tokens-pane .created-token-value {\n    font-family: ui-monospace, monospace;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
